const MAX_RATING = 10
const REVIEWS_TO_DISPLAY = 5

let container

function toggleScales() {
  const { parentNode } = this

  parentNode.classList.add('is-hidden')
  parentNode.parentNode.querySelector('.js-reviews-category').classList.add('is-open')
}

function initCategoryShow() {
  const reviewButton = document.querySelectorAll('.js-reviews-category-show-more')

  for (let i = 0, { length } = reviewButton; i < length; i += 1) {
    reviewButton[i].addEventListener('click', toggleScales);
  }
}

function toggleFilters() {
  this.classList.toggle('is-open')
  this.parentNode.querySelector('.js-filter').classList.toggle('is-open')
}

function initFilterShow() {
  const filterButton = document.querySelectorAll('.js-filter-show-button')

  for (let i = 0, { length } = filterButton; i < length; i += 1) {
    filterButton[i].addEventListener('click', toggleFilters);
  }
}

function initAnimateScales() {
  const items = document.querySelectorAll('.js-scale-item');

  function onChange(changes, observer) {
    changes.filter(change => change.intersectionRatio > 0).forEach(change => {
      const { target } = change
      const width = target.getAttribute('data-scale')

      target.style.width = width
      const scoreItems = target.parentNode.querySelectorAll('.js-scale-text-score')

      if (scoreItems.length > 0) {
        const num = Math.floor(parseFloat(width) / 33.3)

        for (let counter = 0; counter < num; counter += 1) {
          scoreItems[counter].classList.add('has-background')
        }
      }

      observer.unobserve(target)
    });
  }

  const config = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  }

  const observer = new IntersectionObserver(onChange, config)

  items.forEach(item => {
    observer.observe(item)
  })
}

function toggleText(e) {
  e.preventDefault()

  const { classList } = e.target.parentNode.querySelector('.js-show-more-content')
  const isOpen = classList.toggle('is-open')

  this.textContent = isOpen ? 'Show less' : 'Show more'
}

function initShowMoreTextLinks() {
  const maxReviewTextLength = 180

  Array
    .from(container.querySelectorAll('article'))
    .forEach(review => {
      const showMoreButton = review.querySelector('.js-show-more-button')
      const { textContent } = review.querySelector('.js-show-more-content')
      const reviewTextLength = textContent.trim().length

      if (reviewTextLength < maxReviewTextLength) {
        showMoreButton.style.display = 'none'
      } else {
        review.querySelector('.js-show-more-content').classList.add('is-truncated')
        showMoreButton.addEventListener('click', toggleText)
      }
    })
}

function getFilters(type) {
  const { parentNode } = document.getElementById(`js-customer-reviews-${type}`)

  return []
    .slice.call(parentNode.querySelectorAll('[type=checkbox]'))
    .filter(checkbox => checkbox.checked)
}

function inRange(rating, [low, high]) {
  const isExcellent = rating === MAX_RATING && high === MAX_RATING
  const isInRange = rating >= low && rating < high

  return isExcellent || isInRange
}

function getFilteredReviews(type) {
  const reviewsContainer = document.getElementById(`js-customer-reviews-${type}`)
  const reviews = reviewsContainer.querySelectorAll('article')

  const filters = getFilters(type)

  if (filters.length === 0) {
    return [].slice.call(reviews)
  }

  const ranges = filters.map(({ value }) => value.split('..').map(parseFloat))
  const filteredReviews = []

  reviews.forEach(review => {
    const isInRange = ranges.some(range =>
      inRange(parseFloat(review.dataset.rating), range)
    )

    if (isInRange) {
      filteredReviews.push(review)
    }
  })

  return filteredReviews
}

function showMoreReviews(e) {
  const { target } = e
  const type = target.id.split('-').pop()
  const hiddenReviews = getFilteredReviews(type)
    .filter(review => review.classList.contains('is-hidden'))

  hiddenReviews.slice(0, REVIEWS_TO_DISPLAY).forEach(review => {
    review.classList.remove('is-hidden')
  })

  if (hiddenReviews.length <= REVIEWS_TO_DISPLAY) {
    // eslint-disable-next-line
    disableShowMoreButton(target)
  }
}

function disableShowMoreButton(button) {
  button.classList.add('is-hidden')
  button.disabled = true
  button.removeEventListener('click', showMoreReviews)
}

function enableShowMoreButton(button) {
  button.disabled = false
  button.classList.remove('is-hidden')
  button.addEventListener('click', showMoreReviews)
}

function showReviews(type) {
  const reviewsContainer = document.getElementById(`js-customer-reviews-${type}`)

  if (!reviewsContainer) {
    return
  }

  reviewsContainer.querySelectorAll('article').forEach(review => {
    review.classList.add('is-hidden')
  })

  const reviews = getFilteredReviews(type)
  const showMoreReviewsButton = document.getElementById(`js-show-more-${type}`)

  if (showMoreReviewsButton) {
    if (reviews.length > REVIEWS_TO_DISPLAY) {
      enableShowMoreButton(showMoreReviewsButton)
    } else {
      disableShowMoreButton(showMoreReviewsButton)
    }
  }

  const { classList } = reviewsContainer.parentNode.querySelector('.js-no-results')

  if (reviews.length === 0) { // show "No results"
    classList.add('is-visible')

    return
  }

  classList.remove('is-visible')
  reviews
    .slice(0, REVIEWS_TO_DISPLAY)
    .forEach(review => {
      review.classList.remove('is-hidden')
    })
}

function initFilters(type) {
  const reviewsContainer = document.getElementById(`js-customer-reviews-${type}`)

  if (!reviewsContainer) {
    return
  }

  const filterCheckboxes = reviewsContainer.parentNode.querySelectorAll('[type=checkbox]')

  function oncheckboxchange() {
    showReviews(type)
  }

  filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', oncheckboxchange)
  })
}

function initReviews() {
  container = document.querySelector('[data-new-reviews]')

  if (!container) {
    return
  }

  initCategoryShow()
  initFilterShow()
  initAnimateScales()
  initShowMoreTextLinks()

  const types = ['hotels', 'courses']

  types.forEach(type => {
    initFilters(type)
    showReviews(type)
  })
}

export default initReviews



// WEBPACK FOOTER //
// ./components/venue_reviews.js